import { SVGInterface } from "../../interface";

const North = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 1L8.25 10.145L8.605 10.5L12 8.99997L15.395 10.5L15.75 10.145L12 1Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M6.5 12H8.91422L15.5 20.5858L15.5 12H17.5L17.5 23H15.0858L8.5 14.4142L8.5 23H6.5L6.5 12Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default North;
